// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseCardTemplate_container_3re91","image":"BaseCardTemplate_image_VHqeR","content":"BaseCardTemplate_content_2U7zy"};